import React, { useEffect, useState } from "react";
import TimeStamp from "react-timestamp";

import axios from "axios";
import { server } from "../../../utills/utils";

import styled from "styled-components";

import Order from "./Order/PendingOrder";
import Modal from "../../Modals/SignModal";
import OrderedItem from "./Order/OrderedItem";
import Spinner from "../../Modals/SpinnerModal";

import NotFound from "../../Common/NotFoundSearch";

const Container = styled.div`
  width: 100%;
  height: 100%;
`;
const ViewOrder = styled.div`
  width: 100%;
  height: 83vh;
  padding: 2%;
`;
const OrderHeader = styled.div`
  width: 100%;
  height: 8%;
`;
const OrderBody = styled.div`
width: 100%;
height: 85%;
overflow-y: scroll;
`;
const OrderFooter = styled.div`
  width: 100%;
  height: 15%;
  border-top: 1px solid #eee;
`;
const HeaderTitle = styled.h3`
  float: left;
  margin: 0;
  padding: 5px 0;
  font-weight: 500;
`;
const OrderTime = styled.p`
  float: right;
  margin: 0;
  padding: 8px 0;
  color: gray;
`;
const TotalItem = styled.h3`
  float: left;
  margin: 0;
  padding: 5px 0;
  font-weight: 400;
  font-size: 1em;
  width: 50%;
  text-align: left;
`;
const TotalPrice = styled.h3`
  float: right;
  margin: 0;
  padding: 5px 0;
  font-weight: 500;
  font-size: 1em;
  width: 50%;
  text-align: right;
`;
const Button1 = styled.button`
  padding: 10px 0;
  font-size: 1em;
  background: #ff5d5d;
  border: none;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  width: 100%;
  margin: 5px 0;
`;

const DeliveryAddress = styled.div`
  width: 100%;
  height: 200%;
  text-align: left;
`;
const Title = styled.h3`
  padding: 0;
  font-weight: 500;
  font-size: 1em;
  margin: 0;
`;
const SubTitle = styled.p`
  padding: 5px 0;
  font-weight: 400;
  font-size: 1em;
  margin: 0;
`;
function ConfirmedOrders() {
  const [view, setView] = useState(false);
  const [order, setOrder] = useState({});
  const [orders, setOrders] = useState([]);
  const [complete, setComplete] = useState(false);
  const [orderView, setOrderView] = useState(false);
  const [spinner, setSpinner] = useState(false);


  const fectchOrders = async () => {
    try {
      const orders = await axios.post(server, {
        query: `
                    query{
                      confirmedOrders(token:"${localStorage.TOKEN}"){
                            _id
                            shopId
                            userId
                            total
                            address
                        contactName
                        contactNumber
                            orderedProducts{
                                itemId
                                price
                                quantity
                                image
                                name
                            }
                        }
                    }
                  `,
      });
      console.log(orders);
      setOrders(orders.data.data.confirmedOrders);
      setComplete(true);
    } catch (error) {
      throw error;
    }
  };

  const orderViewHandler = async (id) => {
    setSpinner(true);
    // setView(true);
    const order = await axios.post(server, {
      query: `
                 query{
                     order(orderId:"${id}"){
                        _id
                        shopId
                        userId
                        createdAt
                        address
                        contactName
                        contactNumber
                        orderedProducts{
                            itemId
                            price
                            quantity
                            image
                            name
                        }
                     }
                 }
              `,
    });
    setOrder(order.data.data.order);
    setOrderView(true);
    setSpinner(false);
    setView(true);
    console.log(order);
  };
  const deliverOrderHandler = async () => {
    try {
      setView(false);
      setSpinner(true);
      await axios.post(server, {
        query: `
                    mutation{
                        deliverOrder(orderId: "${order._id}"){
                            _id
                            shopId
                            userId
                            total
                            orderedProducts{
                                itemId
                                price
                                quantity
                                image
                                name
                            }
                        }
                    }
                  `,
      });
      const updtedOrders = orders.filter(or=>{
          return or._id !== order._id
      });
      setOrders(updtedOrders);
      setSpinner(false);
    } catch (error) {
      throw error;
    }
  };
  const orderViewCloseHandler = () => {
    setView(false);
  };
  let total = 0;

  useEffect(() => {
    fectchOrders();
  }, []);
  return (
    <Container>
      <Spinner show={spinner}/>
      <Modal show={view} closeModal={orderViewCloseHandler}>
        {
            orderView ?
            <ViewOrder>
            <OrderHeader>
              <HeaderTitle>You have an order</HeaderTitle>
              <OrderTime>
                <TimeStamp time={order.createdAt} />
              </OrderTime>
            </OrderHeader>
            <OrderBody>
              {order.orderedProducts.map((product, id) => {
                total += product.price * product.quantity;
                return <OrderedItem key={id} cartItem={product} />;
              })}
            </OrderBody>
            <OrderFooter>
              <div style={{ width: "100%", height: "40px" }}>
                <TotalItem>
                  {order.orderedProducts.length} items ordered
                </TotalItem>
                <TotalPrice>Total Amount : {total} TK</TotalPrice>
              </div>
              {/* <div style={{ width: "100%" }}>
                <Button2 onClick={cancelOrderHandler}>Cancel</Button2>

                <Button1 onClick={confirmOrderHandler}>Confrim</Button1>
              </div> */}
            </OrderFooter>
          </ViewOrder>: null
        }
      </Modal>

      {complete ? (
        orders.length > 0 ?
        orders.map((order) => {
          return (
            <Order
              key={order._id}
              order={order}
              orderViewHandler={orderViewHandler}
            />
          );
        }):<NotFound title="No confirmed orders" subTitle="Sorry we dont't find pending orders for you." />
      ) : (
        <p>Loading...</p>
      )}
    </Container>
  );
}

export default ConfirmedOrders;
